var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container button",class:{ disable: _vm._disabled },attrs:{"tabindex":"0"}},[_c('input',{style:({ backgroundColor: _vm.color, padding: _vm.padding, width: _vm.width }),attrs:{"id":_vm.id,"type":"button","disabled":_vm._disabled,"value":_vm.label},on:{"click":_vm.validate}})])
}
var staticRenderFns = []

export { render, staticRenderFns }